import(/* webpackMode: "eager" */ "/home/interim/frontend/app/about/team/page.tsx");
